import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PERMISSIONS, SVG_ICONS } from '../../constants';
import AddNewPlayerComp from '../../containers/Teams/addNewPlayerComp';
import AssignedPlayersTable from '../../containers/Teams/AssignedPlayersTable';
import AvailablePlayersList from '../../containers/Teams/AvailablePlayersList';

import { checkPermisson } from '../../selectors/common';
import { getPlayersFromState, getSelectedPlayers } from '../../selectors/teams';
import SVGComponent from '../SVG/SVGComponent';
import { aDisablePlayerRequest, aGetPlayersRequest, aSaveNewPlayerRequest, aSaveUpdatedSquadListRequest, aUpdatePlayersOnSquad } from '../../reducers';
import { aClearTeamDetails } from '../../reducers/teams';

const mapToProps = (state) => ({
  players: getPlayersFromState(state),
  selectedPlayers: getSelectedPlayers(state),
  checkPermisson: (payload) => checkPermisson(state, payload),

});

const actionsToProps = (dispatch) => ({
  getPlayers: (payload) => dispatch(aGetPlayersRequest(payload)),
  saveNewPlayer: (payload) => dispatch(aSaveNewPlayerRequest(payload)),
  disablePlayer: (payload) => dispatch(aDisablePlayerRequest(payload)),
  saveUpdatedSquadList: (payload) => dispatch(aSaveUpdatedSquadListRequest(payload)),
  clearTeamDetails: (payload) => dispatch(aClearTeamDetails(payload)),
  updatePlayerOnSquadList: (payload) => dispatch(aUpdatePlayersOnSquad(payload)),

});

class TeamsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddPlayerField: false,
      newPlayerName: '',
      newPlayerDisplayName: '',
    };
    this.editDisabled = true;
  }

  componentDidMount() {
    this.props.getPlayers({
      competitorId: this.props.selectedTeam,
    });
  }

  componentWillUnmount() {
    this.props.clearTeamDetails();
  }

  toggleAddPlayerField = () => {
    this.setState({
      showAddPlayerField: !this.state.showAddPlayerField,
    });
  };

  handleNewPlayerInputChange = (e) => {
    e.persist();
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  saveNewPlayer = () => {
    this.props.saveNewPlayer({
      playerName: `Z${this.state.newPlayerDisplayName.trim()}Z`,
      referenceName: this.state?.newPlayerName || null,
      competitorId: this.props.selectedTeam,
    });

    this.setState({
      newPlayerName: '',
      newPlayerDisplayName: '',
    });
  };

  disablePlayer = (playerId) => {
    this.props.disablePlayer({
      playerId,
    });
  };

  confirmSquad = () => {
    this.props.saveUpdatedSquadList({
      competitorId: this.props.selectedTeam,
      selectedLeague: this.props.selectedLeague,
      squad: this.props.players,
    });

    this.props.closeModal();
  };

  isConfirmBtnEnabled = () => this.props.selectedPlayers
    ?.every((player) => player.squad_position !== 0
      && player.squad_position !== null);

  getSelectedTeamDetails = () => {
    const selectedLeague = this.props.competitors?.find((comp) => comp?.id
      === this.props.selectedLeague);
    const selectedLeagueName = selectedLeague?.name;
    const selectedTeamName = selectedLeague?.competitors?.find((team) => team.id
      === this.props.selectedTeam)?.name;

    return {
      selectedLeagueName,
      selectedTeamName,
    };
  };

  render() {
    const { selectedLeagueName, selectedTeamName } = this.getSelectedTeamDetails();

    let defaultProbabilities;
    if (!this.props.selectedTeamSquadCompleted) {
      defaultProbabilities = this.props.leagues
        ?.find((league) => league?.id === this.props.selectedLeague)?.teamsGoalscorerPercentages;
    }

    return (
      <div className="modal modal--open">
        <div className="dialog dialog--selection">
          <div className="dialog__heading">
            <span className="dialog__title">
              {`Team Settings - ${selectedLeagueName} - ${selectedTeamName}`}
            </span>

            <SVGComponent
              className="dialog__close"
              src={`${SVG_ICONS.utility}#close`}
              onClick={this.props.closeModal}
            />

          </div>
          <div className="dialog__content">
            <div className="team-section d-flex">
              <div className="team-section__wrap justify-content-between">
                <div className="team-section__inner-wrap">
                  <div className="team-section__title">Players</div>

                  <AvailablePlayersList
                    playersList={this.props.players}
                    disablePlayer={this.disablePlayer}
                    checkPermisson={this.props.checkPermisson}
                    editDisabled={this.editDisabled}
                  />

                </div>

                {this.props.checkPermisson(PERMISSIONS.GOALSCORER_PLAYERS_ADD) && !this.editDisabled
                  ? (
                    <AddNewPlayerComp
                      toggleAddPlayerField={this.toggleAddPlayerField}
                      showAddPlayerField={this.state.showAddPlayerField}
                      savePlayer={this.saveNewPlayer}
                      newPlayerName={this.state.newPlayerName}
                      newPlayerDisplayName={this.state.newPlayerDisplayName}
                      handleNewPlayerInputChange={this.handleNewPlayerInputChange}
                    />
                  )
                  : null}

              </div>

              <div className="team-section__wrap m-l-20">
                <div className="team-section__title">Roles</div>

                <AssignedPlayersTable
                  playersList={this.props.players}
                  updatePlayerOnSquadList={this.props.updatePlayerOnSquadList}
                  selectedPlayers={this.props.selectedPlayers}
                  checkPermission={this.props.checkPermisson}
                  selectedTeamSquadCompleted={this.props.selectedTeamSquadCompleted}
                  defaultProbabilities={defaultProbabilities}
                  editDisabled={this.editDisabled}

                />

              </div>

            </div>
          </div>

          {this.props.checkPermisson(PERMISSIONS.GOALSCORER_SQUAD_UPDATE) && !this.editDisabled
            ? (
              <div className="dialog__btn-wrap">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.props.closeModal}
                >
                  Cancel
                </button>
                {' '}
                <button
                  type="button"
                  className="btn btn-primary m-l-10"
                  onClick={this.confirmSquad}
                  disabled={!this.isConfirmBtnEnabled()}
                >
                  Confirm
                </button>
              </div>
            )
            : null}
          {this.editDisabled && (
            <div className="dialog__btn-wrap">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.props.closeModal}
              >
                ok
              </button>
            </div>
          )}
        </div>

      </div>
    );
  }
}

export default connect(mapToProps, actionsToProps)(TeamsModal);
